<template>
  <Modal :id="'cmp-royalty-contracts-sidewindow-add_releases'" @cancelled="onCancel">
    <template  slot="header">{{ $dft.snakeCaseToWords("releases") }}
      <span v-show="already_in" style="display: flex;
             padding-top: 2px;
             color: red;
             text-transform: initial;
             font-size: 13.4px;">{{ $t('contract_release_already_in_same_ra_warn') }}</span>
    </template>

    <template slot="body">

      <div style="padding-bottom: 10px;" class="body-container">
        <SearchList :id="'releases'" :items="items" :keyProperty="'release_id'" :label="'label_name'"
          :placeholder="'Search releases'" :selectionNumber="'multiple'" @searched="onReleasesSearched"
          @selected="onReleasesSelected">
          <template v-slot:item="{ item }">
            <tr class="dt-table2--row">
              <dt class="dt-table2--column" style="border-right:1px solid #fefefe">
                <div class="ut-flex">
                  <div class="checkbox-container">
                    <div class="dt-checkbox v2 s1">
                      <input type="checkbox" :name="item.release_id" :id="item.release_id"
                        :checked="selectedReleases.has(item.release_id)"
                        @click="e => onCheckboxChange(e, 'name', item)" />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                  <div class="txtov">
                    {{ item.identifier }}
                  </div>
                </div>
              </dt>
              <dt class="dt-table2--column release-name">
                <div class="txtov">
                  {{ item.release_name }}
                </div>
              </dt>
              <dt class="dt-table2--column">
                <div class="txtov">
                  {{ item.release_type }}
                </div>
              </dt>
              <dt class="dt-table2--column">
                <div class="txtov">
                  {{ item.label_name }}
                </div>
              </dt>
              <dt class="dt-table2--column release-date">
                <div class="txtov">
                  {{ item.release_date }}
                </div>
              </dt>
            </tr>
          </template>
        </SearchList>
      </div>
      <span v-if="already_in" style="
             padding-top: 5px;
             color: red;
            ">{{ $t('contract_release_already_in_same_ra_warn') }}</span>
    </template>

    <template slot="options">
      <div class="ut-flex share-box">
        <TextField :id="'share'" class="m1" :inputType="'number'" :showLabel="false" v-bind="textFieldConfig"
          :value="share" @valuechanged="onTextFieldValueChange" />

        <span>%</span>
      </div>
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { Subject } from "rxjs";
import { ContractsService } from "../../services/contracts.service";
import { addRemoveSet } from "../../../../utility";
import { EventHooks } from "../../../../plugins/text-field";
import { async } from "rxjs/internal/scheduler/async";

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      textFieldConfig: {
        height: 29,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      },
      already_in: false,
      unrelatedReleases: [],
      searchString: "",
      releaseSearchString: "",
      searchSubject: new Subject(),
      selectedReleases: new Set(),

      start: 0,
      share: 100
    };
  },
  mounted: async function () {
    const res = await ContractsService.newReleases(
      this.contract_id,
      this.start,
      this.searchString
    );
    this.unrelatedReleases = res.data.releases;
  },
  computed: {
    contract_id: function () {
      return this.$route.params.contract_id;
    },
    items: function () {
      return this.unrelatedReleases || [];
    }
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onTextFieldValueChange: function (name, value) {
      this[name] = value;
    },

    onOkClick: async function () {
      const release_ids = Array.from(this.selectedReleases); // Convert to Array,  Join -- convert to string

      const resIds = await ContractsService.makeReleaseRelation({
        contract_id: this.contract_id,
        release_ids,
        share: this.share,
        search: this.releaseSearchString
      });

      const allRelease = await ContractsService.saveReleases(this.contract_id);
      this.$emit("added", allRelease.data);
    },
    onSearchInputKeyup: function (e) {
      this.releaseSearchString = e.target.value;
      this.searchSubject.next(this.releaseSearchString);
    },

    onCheckboxChange: async function (event, name, item) {
      const value = event.target.checked;
      this.selectedReleases = addRemoveSet(
        event.target.checked,
        this.selectedReleases,
        item.release_id
      );
      const selectedReleases = Array.from(this.selectedReleases);
      if (selectedReleases.length > 0) {
        const res = await ContractsService.isReleasesAlreadyInSameRA(this.contract_id, selectedReleases.join(','));
        this.already_in = res.data.already_in == '1' ? true : false;
      }
      else{
        this.already_in=false;
      }

    },

    onReleasesSearched: async function (searchString) {
      this.releaseSearchString = searchString;

      const res = await ContractsService.newReleases(
        this.contract_id,
        this.start,
        this.releaseSearchString
      );
      this.unrelatedReleases = res.data.releases;
    },

    onReleasesSelected: function (selected) {
      this.selectedReleases = selected;
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-add_releases {


  .m1 {
    width: 80px;
    margin: 0 !important;
  }

  .share-box {
    margin-right: 20px;

    span {
      padding-left: 3px;
    }
  }

  .ut-flex {
    .checkbox-container {
      width: 32px;
    }
  }

  .release-name {
    flex: 2 !important;
  }

  .release-date {
    max-width: 90px;
  }
}
</style>
